import { FC } from "react";
import { Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

interface CsvDownloadDialogColumnsHeaderProps {
  onToggleCollapsed(): void;
  collapsed: boolean;
}

export const CsvDownloadDialogColumnsHeader: FC<
  CsvDownloadDialogColumnsHeaderProps
> = ({ onToggleCollapsed, collapsed }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      py={1.5}
      bgcolor="white"
      px={1}
      onClick={onToggleCollapsed}
      sx={{ cursor: "pointer" }}
      justifyContent="space-between"
    >
      <Stack direction="row" spacing={1} alignItems="center">
        {collapsed ? <KeyboardArrowDownIcon /> : <ChevronRightIcon />}

        <SettingsOutlinedIcon fontSize="small" />

        <Typography variant="body2" fontWeight="medium" color="">
          Configure Columns
        </Typography>
      </Stack>
    </Stack>
  );
};
